/*
 * Post-product.ts
 * Description: Includes the declaration
 * of the function for creating a product
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing functions
import {getFormData} from '@/ts/helpers';

/**
 * Create a product
 *
 * @return {Object} Promise - when the request is done
 * @param {String} slug - id of a restaurant
 * @param {Number} categoryId - id of a category
 * @param data - product data
 */
export function postProduct(data: any, slug: string, categoryId: number) {
    const jwt = localStorage.getItem('jwt');
    // TODO: test if this can actually work and may be remove it from here
    if (categoryId !== Number()) {
        data.menu_category_id = categoryId;
    }
    // Turning objects into strings
    data.tags = JSON.stringify(data.tags);
    data.ingredients = JSON.stringify(data.ingredients);
    data.addons = JSON.stringify(data.addons);
    data.variations = JSON.stringify(data.variations);
    // Turning data into FormData
    const formData = getFormData(data);
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug + '/products',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: formData,
        }).then(() => {
            resolve();
        }).catch((error) => {
            reject(error);
        });
    });
}
